import { Component,Watch } from "vue-property-decorator";
import BaseCurd from "@/components/BaseCurd/template";
import { ProcessServiceProxy ,WorkStationGroupServiceProxy } from "@/service-proxies/app-v2/workStation.service-proxies";
import {
  importProductionOrder,
  exportProductionOrder,
  downloadProductionOrderTemplate,
} from "@/api/api";
import { CodeRuleServiceProxy } from "@/service-proxies/app-v2/code.service-proxies";
const service = new ProcessServiceProxy();
const wsgsp = new WorkStationGroupServiceProxy();
const crsp = new CodeRuleServiceProxy();
@Component
export default class Employee extends BaseCurd {
  name = "process";
  visable = false;
  options = {
    retrieve: service.getPageProcess.bind(service),
    search: service.getProcess.bind(service),
    create: service.createOrUpdateProcess.bind(service),
    update: service.createOrUpdateProcess.bind(service),
    delete: service.deleteProcess.bind(service),
    placeFile: service.createOrUpdateProcess.bind(service)
  };
  acl = {
    create: "page_process_create",
    update: "page_process_update",
    delete: "page_process_delete",
  };
  scroll = {};

  ie = true;
  type = "wrangDown"
  importFilename = "生产工序.xlsx";
  exportFilename = "生产工序.xlsx";
  downloadFn = downloadProductionOrderTemplate;
  importFn = importProductionOrder;
  exportFn = exportProductionOrder;
  isShowPlaceFile = true;
  render() {
    return this.customRender();
  }
  getChange(val) {
    // console.log("val", val);
    this._form_2.form.setFieldsValue({["code"]:""})
    // console.log(11111,this._form_2.form.getFieldValue('code'))
    this.visable = !!val;
  }

  @Watch("showDialog")
  handleDialogChange(val) {
    if (val === true) {
      // console.log(1111, val);
      this.visable = false;
    }
  }

  get columns() {
    return [
      {
        title: this.$t("page_process_code"),
        dataIndex: "code",
        key: "code",
        width: 200,
        ellipsis: true,
      },
      {
        title: this.$t("page_process_name"),
        dataIndex: "name",
        key: "name",
        width: 180,
        ellipsis: true,
      },
      {
        title: this.$t("page_process_type"),
        dataIndex: "type",
        key: "type",
        width: 180,
        ellipsis: true,
      },
      {
        title: this.$t("page_process_description"),
        dataIndex: "description",
        key: "description",
        width:200,
        ellipsis: true,
        customRender: (text, record) => {
          return (
            <ellipsis length={50} tooltip>
              {text}
            </ellipsis>
          );
        },
      },
      {
          title: this.$t("page_plan_station_coding"),
        dataIndex: "workStationIds",
        key: "workStationIds",
        width: 200,
        ellipsis:true,
      },
    ];
  }

  get schema() {
    return {
      codeRuleId: {
        label: this.$t("page_system_coding_rules"),
        type: "select",
        display: this.showDrawer ? "none" : "block",
        placeholder: this.$t("page_system_select_coding_rule"),
        props: {
          allowClear: true,
          maxLength: 32,
        },
        options: async () => {
          const list = await crsp.list("ProcessObject");
          // console.log("qqqqqqq",data)
          return list.map((item) => ({ label: item.name, value: item.id }));
        },
        on: {
          change: this.getChange,
        },
        // onClick: this.getList(),
        disabled: true,
      },
      code: {
        label: this.$t("page_process_code"),
        type: "input",
        placeholder: this.$t("page_process_add_code"),
        props: {
          maxLength: 32,
          disabled: this.visable = this.showDrawer ? true : this.visable,
        },
        rules: [
          {
            required: !this.visable,
            message: this.$t("page_process_add_code"),
          },
        ],
      },
      name: {
        label: this.$t("page_process_name"),
        type: "input",
        placeholder: this.$t("page_process_add_name"),
        props: {
          maxLength: 32,
        },
        rules: [
          {
            required: true,
            message: this.$t("page_process_add_name"),
          },
        ],
      },
      type: {
        label: this.$t("page_process_type"),
        type: "input",
        placeholder: this.$t("page_process_add_type"),
        props: {
          maxLength: 32,
        },
      },
      description: {
        label: this.$t("page_process_description"),
        type: "textarea",
        placeholder: this.$t("page_process_add_description"),
        props: {
          maxLength: 255,
        },
      },
      workStationIds: {
        label:this.$t("page_quality_station"),
        type: "treeSelect",
        props: {
          treeCheckable: false,
          multiple: true,
          allowClear: true,
          maxTagCount: 3,
        },
        placeholder: this.$t("page_select_station"),
        options: async () => {
          const data = await wsgsp.allWorkStationGroupList();
          let workStationList = []
          let h = []
            data.map(k =>{
              if(k.parentId == "0" || k.parentId === null) {
                workStationList.push(k)
              }else {
                h.push(k)
              }
            })
            const list = function(obj,h){
              obj["children"] = []
              h.map(k => {
                if(obj.id === k.parentId){
                  obj.children.push(k)
                  panduan(k,h)
                }
              })
            }
            const getlist = function(treeData,h){
              treeData.map(item=>{
                panduan(item,h)
              })
            }
            const panduan = function(ii,h){
              if(ii.isGroup){
                list(ii,h)
              }
            }
            getlist(workStationList,h)
          return tranformTreeShape(workStationList)
        },

      },
    };
  }

  renderHeader(slot = null) {
    const { hidden } = this;

    const add = hidden.includes("create") ? null : (
      <a-button
        v-acl={this.acl.create}
        type="primary"
        style={{ marginRight: "8px" }}
        onClick={this.openCreateWindow}
      >
        {this.lang.create}
      </a-button>
    );

    const del = hidden.includes("delete") ? null : (
      <a-popconfirm
        title={this.$t("page_resource_pool_confirm_delete")}
        onConfirm={this.deleteData}
        okText={this.$t("yes")}
        cancelText={this.$t("no")}
        disabled={this.selectedIds.length < 1}
      >
        <a-button
          v-acl={this.acl.delete}
          type="danger"
          disabled={this.selectedIds.length < 1}
        >
          {this.lang.delete}
        </a-button>
      </a-popconfirm>
    );

    const printing = hidden.includes("printing") ? null : (
      <a-button
        type="default"
        style={{ marginLeft: "8px" }}
        onClick={() =>this.printing()}
        disabled={this.selectedIds.length === 0}
      >
        {this.$t("page_print_code")}
      </a-button>
    );

    return (
      <div
        slot="action"
        style={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <div>
          {add}
          {del}
          {this.ie ? this.extraHeaderAction() : null}
          {printing}
        </div>
        {this.showSearch ? ( <div style="display:flex;align-items:center">
          {slot}
          <a-input-search
            placeholder={this.lang.placeholder}
            onSearch={this.onSearch}
            enterButton={this.lang.search}
            allowClear={true}
          ></a-input-search>
        </div>) : null}
      </div>
    );
  }

}
  const tranformTreeShape = (data) => {
    let arr = []
    const hg = function(object,ele){
      if(object.children && object.children.length > 0){
        for(const k of object.children){
          const param = {
            title:k.title,
            value:k.id,
            children:k.children ?[] :null,
            disabled: !k.isWorkStation,
          }
          ele.children.push(param)
          hg(k,param)
        }
      }
    }
      for(const obj of data){
        const param = {
          title:obj.title,
          value:obj.id,
          children:obj.children ?[] :null,
          disabled: !obj.isWorkStation,
        }
        hg(obj,param)
        arr.push(param)
      }
    return arr
  };
